import { useQuery } from '@tanstack/react-query'
import { getSmokerRateOverrideRule } from '../../../api/plan-smoker-rate-override-rules-api'

export const SMOKER_RATE_OVERRIDE_RULE_QUERY_KEY = 'smokerRateOverrideRule'

export function useGetSmokerRateOverrideRule(id?: string) {
  return useQuery({
    queryKey: [SMOKER_RATE_OVERRIDE_RULE_QUERY_KEY, id],
    queryFn: () => getSmokerRateOverrideRule(id as string),
    enabled: Boolean(id),
    staleTime: 30_000,
  })
}
